import React, { ReactNode } from 'react';
import { Box, Cell } from '@wix/design-system';

export interface EntityPageMainContentProps {
  /**
   * Applies a data-hook HTML attribute that can be used in tests
   */
  dataHook?: string;
  children?: ReactNode;
}

export function EntityPageMainContent(props: EntityPageMainContentProps) {
  const { children, ...rest } = props;
  return (
    <Cell {...rest}>
      <Box direction="vertical" gap="SP4">
        {children}
      </Box>
    </Cell>
  );
}

EntityPageMainContent.displayName = 'EntityPageMainContent';
